import type { Theme } from "../types";

export const amber80s: Theme = {
  name: "amber80s",
  bg: "#1a0e04",
  textPrimary: "#ffb020",
  textBright: "#ffb020",
  textDim: "#ffb020",
  textAccent: "#ffb020",
  scrollbarThumb: "#ffb020",
  scrollbarThumbHover: "#ffb020",
  scanlines: true,
  glow: "0 0 8px rgba(255, 140, 0, 0.45)",
  fontFamily: "'VT323', monospace",
  fontUrl: "https://fonts.googleapis.com/css2?family=VT323&display=swap",
  fontSize: "30px",
  lineHeight: "1.2",
  letterSpacing: "0.04em",
  fontWeight: "lighter",
  bgOverlay: null,
};
